/** Onglets du profil (`/$tenant/me?tab=`) : « Mon fil » puis « Abonnements ». */
export const PROFILE_TABS = ['feed', 'following'] as const;
export type ProfileTab = (typeof PROFILE_TABS)[number];
export const isProfileTab = (value: unknown): value is ProfileTab =>
  PROFILE_TABS.some((tab) => tab === value);
